import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../directives/header";
import Sidebar from "../directives/sidebar";
import Footer from "../directives/footer";
import config from "../coreFIles/config";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import {
  getCmsPagesAction,
  deleteCmsPageAction,
  CmsPageBlockUnBlockAction,
} from "../Action/action";

const Pages = () => {
  const loginData = !Cookies.get("loginSuccessfastenerwarehouseAdmin")
    ? []
    : JSON.parse(Cookies.get("loginSuccessfastenerwarehouseAdmin"));
  if (!loginData || loginData === "") {
    window.location.href = `${config.baseUrl}`;
  }
  if (loginData.role != config.role_admin) {
    window.location.href = `dashboard`;
  }

  const [list, setList] = useState([]);
  const [spinloader, setspinloader] = useState(1);

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    const res = await getCmsPagesAction({});
    if (res.success) {
      setList(res.data || []);
    } else {
      setList([]);
    }
    setspinloader(0);
  };

  const deleteRow = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this page! It will no longer appear on the website.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const res = await deleteCmsPageAction({ id });
      if (res.success) {
        toast.success(res.msg);
        getList();
      } else {
        toast.error(res.msg);
      }
    });
  };

  const handleStatus = async (id, is_active) => {
    Swal.fire({
      title: "Are you sure?",
      text:
        is_active === 0
          ? "Are you sure you want to hide this page on the website?"
          : "Are you sure you want to show this page on the website?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: is_active == 0 ? "Yes, Hide it!" : "Yes, Show it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const res = await CmsPageBlockUnBlockAction({ id, is_active });
      if (res.success) {
        getList();
        toast.success(is_active == 0 ? "Page hidden successfully!" : "Page published successfully!");
      } else {
        toast.error(res.msg);
      }
    });
  };

  return (
    <>
      <Sidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <Toaster />
        <Header />
        <div className="container-lg mb-4">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb my-0 ms-2">
              <li className="breadcrumb-item">
                <span>
                  <a className="homelink" href={`${config.baseUrl}dashboard`}>
                    Home
                  </a>
                </span>
              </li>
              <li className="breadcrumb-item active">
                <span>Pages</span>
              </li>
            </ol>
          </nav>
        </div>
        <div className="body flex-grow-1 px-3">
          <div className="container-lg">
            <div className="row">
              <div className="col-md-12">
                <div className="card mb-4">
                  <div className="card-header">
                    <div className="row align-items-center">
                      <div className="col-md-6 text-start">
                        <span>Pages</span>
                      </div>
                      <div className="col-md-6 text-end">
                        <a className="btn btn-primary createbtn" href={`${config.baseUrl}ad-page`}>
                          <i className="fa fa-plus"></i> Add Page
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table mb-0">
                        <thead className="table-light fw-semibold">
                          <tr className="align-middle table-heading">
                            <th>Sr.</th>
                            <th>Title</th>
                            <th>Slug</th>
                            <th>Sort</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {spinloader == 0 ? (
                            list.length > 0 ? (
                              list.map((item, index) => (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>{item.title}</td>
                                  <td>/{item.slug}</td>
                                  <td>{item.sort_order}</td>
                                  <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={item.is_active === 1}
                                        onChange={() => handleStatus(item.id, item.is_active === 1 ? 0 : 1)}
                                      />
                                    </div>
                                  </td>
                                  <td className="td-action">
                                    <Link to={`${config.baseUrl}edit-page/${item.id}`}>
                                      <button type="button" className="btn btn-primary editbtn">
                                        <i className="far fa-edit"></i> Edit
                                      </button>
                                    </Link>
                                    &nbsp;&nbsp;
                                    <button
                                      type="button"
                                      className="btn btn-primary deletebtn"
                                      onClick={() => deleteRow(item.id)}
                                    >
                                      <i className="fa fa-trash"></i> Delete
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No pages found.
                                </td>
                              </tr>
                            )
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                <img
                                  className="loaderImg search-loader"
                                  src={config.baseUrl + "images/loader.gif"}
                                  height={20}
                                  width={20}
                                  alt=""
                                />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Pages;
